import { render } from "./UserBilling.vue?vue&type=template&id=20b6c6ca"
import script from "./UserBilling.vue?vue&type=script&lang=js"
export * from "./UserBilling.vue?vue&type=script&lang=js"

import "./UserBilling.vue?vue&type=style&index=0&id=20b6c6ca&lang=scss"
script.render = render

export default script